import React, {useState} from "react"
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

export interface DeleteModalProps {
    open: boolean;
    title: string;
    content: string;
    close: ()=>void;
    agree: ()=>void;
};

const DeleteModal: React.FC<DeleteModalProps> = ({
    open, title, content, close, agree
}) => {
    return (
        <Modal isOpen={open} toggle={close} 
            className={"modal-fullscreen-sm-down modal-dialog-centered"}>
            <ModalHeader>{title}</ModalHeader>
            <ModalBody>
                {content}
            </ModalBody>
            <ModalFooter>
                <Button color="danger" onClick={agree}>削除する</Button>{' '}
                <Button color="secondary" onClick={close}>閉じる</Button>
            </ModalFooter>
        </Modal>
    )
}

export default DeleteModal;